import { failureFromResponse, type FollowUpSettingsDto, type SaveFollowUpSettingsRequest } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { campaignHeaders, defineQuery, defineWrite, edit } from '../../lib/data';

const SETTINGS_PATH = '/api/fundraising/follow-up-settings';

/** The campaign's follow-up wording and donation link, for the Fundraiser's editor (Fundraising: Manage). */
export const useFollowUpSettings = defineQuery({
  key: () => ['fundraising', 'follow-up-settings'],
  reads: 'GET /api/fundraising/follow-up-settings',
  fetch: (_: undefined, { signal, campaignId }) =>
    apiJson<FollowUpSettingsDto>(SETTINGS_PATH, { signal, headers: campaignHeaders(campaignId), error: 'Failed to fetch the follow-up settings' }),
});

/**
 * Save the link and all six slots. The response carries the bumped concurrency version, landed in the
 * settings read so the next save sends it. A 400 (unknown field) or 409 (changed elsewhere) rejects
 * with the server's message.
 */
export const useSaveFollowUpSettings = defineWrite({
  send: (request: SaveFollowUpSettingsRequest) =>
    apiJson<FollowUpSettingsDto>(SETTINGS_PATH, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      json: request,
      error: (body, response) =>
        failureFromResponse(response, body, body?.error || body?.message ? undefined : "Couldn't save the follow-ups. Try again."),
    }),
  land: (saved) => [edit(useFollowUpSettings, undefined, () => saved)],
});
